import React from 'react';
import Parent from "../common/Parent";
import PropTypes from "prop-types";
import classnames from "classnames";
import defaultImg from "../../assets/img/default-img.png";

const CompanyInformation = props => (
    <Parent>
      <div className="card-header">
        <h2>{props.user.role === 'general' ? 'Company Information' : 'Manage company information'}</h2>
      </div>
      <div className="card-body account-info">
        <div className="row">
          <div className="col">
            <div className="image-editor">
              <img src={props.image ? props.image : defaultImg} alt="" className="img-preview"/>
              <div className="error-msg"/>
            </div>

            {props.user.role !== 'general' && (
                <div>
                  <label className="import btn btn-lg btn-secondary">
                    Add/Edit logo
                    <input type="file" className="cropit-image-input" id="import" onChange={props.onImageSelect}/>
                  </label>
                  <input id="logo" name="photo" type="hidden" defaultValue/>
                </div>
            )}

          </div>
          <div className="col">
            <div
                className={classnames('form-group', {'invalid': !props.companyName.isValid && props.companyName.touched})}>

              {props.user.role !== 'general' && (
                  <div className="form-group">
                    <label htmlFor="name">Company name</label>
                    <input type="text" id="company-name" className="form-control" placeholder="Company name"
                           name="companyName" value={props.companyName.value} onChange={props.handleUserInput}
                           onBlur={props.handleInputBlur}/>
                    {!props.companyName.isValid && props.companyName.touched && (
                        <p className="error-msg">{props.companyName.errorMessage}</p>)}
                  </div>
              )}

              {props.user.role === 'general' && (
                  <div>
                    <div className="form-group">
                      <label>Company name</label>
                      <p className="form-value">{props.companyName.value}</p>
                    </div>
                    <div className="form-group">
                      <label>Warehouses</label>
                      <ul className="list-warehouses">
                        {props.warehouses.map(wh => (<li className="form-value" key={wh.id}>{wh.name}</li>))}
                      </ul>
                    </div>
                  </div>
              )}

            </div>
          </div>
        </div>
      </div>
    </Parent>
);

CompanyInformation.propTypes = {
  companyName: PropTypes.object.isRequired,
  handleUserInput: PropTypes.func.isRequired,
  handleInputBlur: PropTypes.func.isRequired,
  image: PropTypes.string,
  onImageSelect: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  warehouses: PropTypes.array
};

export default CompanyInformation;



// WEBPACK FOOTER //
// ./src/components/AccountInformation/CompanyInformation.jsx